export const API_URLS = {
    LEGACY: {
        RESET_PASSWORD: '/account/forgottenpassword',
        REGISTRATION: '/public-api/v1/candidate/account',
    },
    BFF: {
        REGISTRATION: '/rlac/login-registration-service/Candidate/Register',
        LOGIN: '/rlac/login-registration-service/Candidate/SignIn',
        APPLE_LOGIN: '/rlac/login-registration-service/oauth/Apple/SignIn',
        TOKEN: '/rlac/login-registration-service/Antiforgery/Token',
        RESET_PASSWORD: '/rlac/login-registration-service/Candidate/ResetPassword',
        GOOGLE_AUTH: '/rlac/login-registration-service/oauth/Google/register',
        VERIFY_ACCOUNT_EXISTS: '/rlac/login-registration-service/Candidate/VerifyAccountExists',
        CHANGE_PRIVATE_RELAY_EMAIL: '/rlac/login-registration-service/Social/ChangePrivateRelayEmail',
    },
    ANALYTICS: {
        STANDARD_PARAMETERS: '/analytics/api/v2/tracking',
    },
    SHARED_ASSETS: {
        LOGO: (logoBrandName) => `/sharedassets/logo/core/${logoBrandName}/logo.svg`,
    },
};
export const SCRIPT_URLS = {
    APPLE_AUTH: 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
};
//# sourceMappingURL=urls.js.map